import React from 'react'
import { Link } from 'react-router-dom'

import './Footer.scss'

import Logo from '../../img/brand-logo.png'

function Footer() {
    return (
        <>
            <footer className='Footer_main'>
                <div className="container">
                    <div className="row row_custom">
                        <div className="col-lg-3 col-md-4 col-sm-6 nav_main_otr">
                            <div className="nav_main_inr nav1">
                                <h3 className="nav_head heading_h3">Navigation</h3>
                                <ul className="nav_ul">
                                    <li className="nav_li">
                                        <Link to="/" className="nav_a heading_S">Home</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="/category" className="nav_a heading_S">Categories</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link className="nav_a heading_S">Stores</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://www.resellerratings.com/" target="_blank" className="nav_a heading_S">Reviews</Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="nav_main_inr nav2" style={{marginTop: '24px'}}>
                                <h3 className="nav_head heading_h3">Quick Links</h3>
                                <ul className="nav_ul">
                                    <li className="nav_li">
                                        <Link to="https://my.buyrdplive.com/index.php?rp=/store/windows-10-rdp/windows-10-rdp-lite" target="_blank" className="nav_a heading_S">Windows 10 RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://my.buyrdplive.com/index.php?rp=/store/windows-11/express-windows-desktop-vps" target="_blank" className="nav_a heading_S">Windows 11 RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://my.buyrdplive.com/index.php?rp=/store/windows-7-rdp/windows-7-rdp-lite" target="_blank" className="nav_a heading_S">Windows 7 RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://my.buyrdplive.com/index.php?rp=/store/windows-server-rdp/windows-server-rdp-lite" target="_blank" className="nav_a heading_S">Windows Server RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://my.buyrdplive.com/index.php?rp=/store/ubuntu-rdp/ubuntu-rdp-lite" target="_blank" className="nav_a heading_S">Ubuntu RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://my.buyrdplive.com/index.php?rp=/store/centos-rdp/centos-rdp-lite" target="_blank" className="nav_a heading_S">CentOS RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://my.buyrdplive.com/index.php?rp=/store/debian-rdp/debian-rdp-lite" target="_blank" className="nav_a heading_S">Debian RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://my.buyrdplive.com/index.php?rp=/store/ai-rdp/ai-rdp-lite" target="_blank" className="nav_a heading_S">AI RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://my.buyrdplive.com/index.php?rp=/store/android-emulators-rdp/android-emulators-rdp-lite" target="_blank" className="nav_a heading_S">Android Emulator RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://my.buyrdplive.com/index.php?rp=/store/streaming-rdp/streaming-rdp-lite" target="_blank" className="nav_a heading_S">Streaming RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://clients.rdpdatabase.com/cart.php?a=confproduct&i=0" target="_blank" className="nav_a heading_S">GPU RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://my.buyrdplive.com/index.php?rp=/store/python-rdp/python-rdp-lite" target="_blank" className="nav_a heading_S">Python RDP</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-6 nav_main_otr">
                            <div className="nav_main_inr nav2">
                                <h3 className="nav_head heading_h3">Quick Links</h3>
                                <ul className="nav_ul">
                                    <li className="nav_li">
                                        <Link to="https://99rdp.com/cheap-rdp/" target="_blank" className="nav_a heading_S">Cheap RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://99rdp.com/streaming-rdp/" target="_blank" className="nav_a heading_S">Streaming RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://amazingrdp.com/graphic-card-rdp/" target="_blank" className="nav_a heading_S">GPU RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://99rdp.com/encoding-rdp/" target="_blank" className="nav_a heading_S">Encoding RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://99rdp.com/rendering-rdp/" target="_blank" className="nav_a heading_S">Rendering RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://amazingrdp.com/10gbps-usa-rdp/" target="_blank" className="nav_a heading_S">10 GBPS RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://amazingrdp.com/private-rdp-vps/" target="_blank" className="nav_a heading_S">Private RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://amazingrdp.com/residential-rdp/" target="_blank" className="nav_a heading_S">Residential RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="" target='_blank' className="nav_a heading_S">Dedicated RDP</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 nav_main_otr">
                            <div className="nav_main_inr nav3">
                                <h3 className="nav_head heading_h3">Stores</h3>
                                <ul className="nav_ul">
                                    <li className="nav_li">
                                        <Link to="https://99rdp.com/" target='_blank' className="nav_a heading_S">99RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://amazingrdp.com/" target='_blank' className="nav_a heading_S">AmazingRDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://homerdp.com/" target='_blank' className="nav_a heading_S">HomeRDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://eurdp.com/" target='_blank' className="nav_a heading_S">EURRDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://gpurdp.com/" target='_blank' className="nav_a heading_S">GPU RDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://rdpdatabase.com/" target='_blank' className="nav_a heading_S">RDPDatabase</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://pcrdp.com/" target='_blank' className="nav_a heading_S">PCRDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://gordp.com/" target='_blank' className="nav_a heading_S">GoRDP</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://99server.com/" target='_blank' className="nav_a heading_S">99Server</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://olivevps.com/" target='_blank' className="nav_a heading_S">OliveVPS</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://serverscafe.com/" target='_blank' className="nav_a heading_S">ServerCafe</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://www.buyrdplive.com/" target='_blank' className="nav_a heading_S">buyrdplive.com</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-6 nav_main_otr">
                            <div className="nav_main_inr nav4">
                                <h3 className="nav_head heading_h3">Company</h3>
                                <ul className="nav_ul">
                                    <li className="nav_li">
                                        <Link to="/about" className="nav_a heading_S">About</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="/blog" className="nav_a heading_S">Blog</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="/contact" className="nav_a heading_S">Contact</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="/review" className="nav_a heading_S">Reviews</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="/" className="nav_a heading_S">Site Map</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="/terms" className="nav_a heading_S">Terms of Use</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="/privacy" className="nav_a heading_S">Privacy Policy</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="/cookie" className="nav_a heading_S">Cookie Policy</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="/disclosure" className="nav_a heading_S">Disclosure Policy</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-6 nav_main_otr">
                            <div className="nav_main_inr nav5">
                                <h3 className="nav_head heading_h3">Follow Us</h3>
                                <ul className="nav_ul">
                                    <li className="nav_li">
                                        <Link to="https://99rdp.com/" target='_blank' className="nav_a heading_S">Facebook</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://99rdp.com/" target='_blank' className="nav_a heading_S">Twitter</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://99rdp.com/" target='_blank' className="nav_a heading_S">Instagram</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://99rdp.com/" target='_blank' className="nav_a heading_S">WhatsApp</Link>
                                    </li>
                                    <li className="nav_li">
                                        <Link to="https://99rdp.com/" target='_blank' className="nav_a heading_S">Telegram</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <div className="copy_main">
                <div className="container">
                    <div className="copy_wrapper">
                        <Link to="/" className="logo_inr">
                            <img className="logo_img" src={Logo} alt="brand-logo" />
                        </Link>
                        <div className="copy_text_otr">
                            <p className="copy_text heading_S">Copyright © <Link to="https://amazeinternet.com/" className="brand heading_SB" target="_blank">AmazeInternet</Link> 2021. All rights reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer